import Cookies from "js-cookie";

export const setBackToBrowsingCookie = function() {
    Cookies.set("backToBrowsing", window.location, {
        path: '/',
        domain: document.domain
    });
};
